// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const MailChainCategories:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'mailChainCategory', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.settings.mailChainCategories.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="mailChainCategory"
    sortingMode="multiple"
  />;
}

function MailChainCategoriesPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<MailChainCategories hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default MailChainCategoriesPortal;
